<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [class.hide-nav]="hideNavComponent"
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="'over'" [(opened)]="sideNavOpen">
    <mat-toolbar class="center-container" style="height: 75px;">
      <img src="assets/images/qwikcut-q-logo.png" style="height: 75%;">
    </mat-toolbar>
    <mat-nav-list>
      <ng-container *ngIf="isCamopManager">
        <a mat-list-item [routerLink]="'/game-manager'" (click)="sideNavOpen = false">
          <mat-icon style="padding-right: 10px;">dns</mat-icon>
          Game Manager
        </a>
        <a mat-list-item [routerLink]="'/schedule-games'" (click)="sideNavOpen = false">
          <mat-icon style="padding-right: 10px;">calendar_month</mat-icon>
          Schedule Games
        </a>
        <a mat-list-item [routerLink]="'/manage-camops'" (click)="sideNavOpen = false" *ngIf="canManageCamops">
          <mat-icon style="padding-right: 10px;">video_camera_front</mat-icon>
          Manage CamOps
        </a>
        <mat-divider></mat-divider>
      </ng-container>
      <a mat-list-item [routerLink]="'/third-party-dashboard'" (click)="sideNavOpen = false" *ngIf="thirdPartyUser">
        <mat-icon style="padding-right: 10px;">analytics</mat-icon>
        Third-Party Dashboard
      </a>
      <ng-container *ngIf="(user?.team || leaguePoolAdmin) && !isShooter && !isStatManager && !isStatistician && !isFan">
        <a mat-list-item [routerLink]="'/home'" (click)="sideNavOpen = false" *ngIf="hasHomePage">
          <mat-icon style="padding-right: 10px;">home</mat-icon>
          Home
        </a>
        <a mat-list-item [routerLink]="'/league-personnel'" (click)="sideNavOpen = false" *ngIf="hasLeaguePool && (leaguePoolAdmin || canSwitchTeams)">
          <mat-icon style="padding-right: 10px;">admin_panel_settings</mat-icon>
          {{ isBoardmember ? 'Organization' : 'League' }} Personnel
        </a>
        <a mat-list-item (click)="navigateToMyVideos(); sideNavOpen = false" *ngIf="!isParent || parentAbilityIsAllowed(teamSettings, 'watchFilm')">
          <mat-icon style="padding-right: 10px;">ondemand_video</mat-icon>
          My Video
        </a>
        <ng-container *ngIf="!leaguePoolAdmin">
          <a mat-list-item [routerLink]="'/my-video-continuous/stats'" (click)="sideNavOpen = false" *ngIf="sportid !== 'wrestling' && continuousSports.includes(sportid) && (!isParent || parentAbilityIsAllowed(teamSettings, 'viewStats'))">
            <mat-icon style="padding-right: 10px;">leaderboard</mat-icon>
            Team Stats
          </a>
          <a mat-list-item [routerLink]="'/manage-video'" (click)="sideNavOpen = false" *ngIf="elevatedPriv && !leaguePoolAdmin">
            <mat-icon style="padding-right: 10px;">video_settings</mat-icon>
            Manage Video
          </a>
          <a mat-list-item [routerLink]="'/my-team'" (click)="sideNavOpen = false" *ngIf="!leaguePoolAdmin">
            <mat-icon style="padding-right: 10px;">groups</mat-icon>
            My Team
          </a>
          <a mat-list-item [routerLink]="'/team-stats'" (click)="sideNavOpen = false" *ngIf="sportid === 'football' && !leaguePoolOnly && (!isParent || parentAbilityIsAllowed(teamSettings, 'viewStats'))">
            <mat-icon style="padding-right: 10px;">leaderboard</mat-icon>
            Team Stats
          </a>
          <a mat-list-item [routerLink]="'/my-fans'" (click)="sideNavOpen = false" *ngIf="canSwitchTeams || user?.currentUserRole?.role === 'teamadmin'">
            <mat-icon style="padding-right: 10px;">scoreboard</mat-icon>
            My Fans
          </a>
          <a mat-list-item [routerLink]="'/playbook/explorer'" *ngIf="sportid === 'football' && !leaguePoolOnly && elevatedPriv" (click)="sideNavOpen = false">
            <mat-icon style="padding-right: 10px;">style</mat-icon>
            Playbook
          </a>
          <a mat-list-item [routerLink]="'/playbook/playbook-installs-athlete'" *ngIf="sportid === 'football' && !leaguePoolOnly && ((isParent && parentAbilityIsAllowed(teamSettings, 'viewPlaybook')) || isAthlete)" (click)="sideNavOpen = false">
            <mat-icon style="padding-right: 10px;">style</mat-icon>
            Playbook
          </a>
          <a mat-list-item [routerLink]="'/game-exchanges'" (click)="sideNavOpen = false" *ngIf="elevatedPriv && !leaguePoolOnly">
            <mat-icon style="padding-right: 10px;">markunread_mailbox</mat-icon>
            Exchange Video
          </a>
          <a mat-list-item [routerLink]="'/qwikcut-camera'" (click)="sideNavOpen = false" *ngIf="elevatedPriv && hasCameras">
            <mat-icon style="padding-right: 10px;">videocam</mat-icon>
            QwikCut Camera(s)
          </a>
        </ng-container>
      </ng-container>
      <!-- <a mat-list-item [routerLink]="'/recruiting-database'" (click)="sideNavOpen = false" *ngIf="isAdmin || isRecruiter">
        <mat-icon style="padding-right: 10px;">travel_explore</mat-icon>
        Recruiting Database
      </a>
      <a mat-list-item [routerLink]="'/saved-prospects'" (click)="sideNavOpen = false" *ngIf="isAdmin || isRecruiter">
        <mat-icon style="padding-right: 10px;">save</mat-icon>
        Saved Prospects
      </a> -->
      <a mat-list-item [routerLink]="'/stat-dashboard'" (click)="sideNavOpen = false" *ngIf="isStatManager">
        <mat-icon style="padding-right: 10px;">analytics</mat-icon>
        Stat Dashboard
      </a>
      <a mat-list-item [routerLink]="'/qwikbuild-dashboard'" (click)="sideNavOpen = false" *ngIf="isStatManager">
        <mat-icon style="padding-right: 10px;">view_timeline</mat-icon>
        QwikBuild Dashboard
      </a>
      <a mat-list-item [routerLink]="'/camop-view-payroll'" (click)="sideNavOpen = false" *ngIf="isShooter && canViewCamopPayroll">
        <mat-icon style="padding-right: 10px;">receipt_long</mat-icon>
        My Payroll
      </a>
      <a mat-list-item [routerLink]="'/camop-assignments'" (click)="sideNavOpen = false" *ngIf="isShooter">
        <mat-icon style="padding-right: 10px;">assignment</mat-icon>
        My Assignments
      </a>
      <a mat-list-item [routerLink]="'/analyst-dashboard/tasks'" (click)="sideNavOpen = false" *ngIf="isStatManager || isStatistician">
        <mat-icon style="padding-right: 10px;">assignment</mat-icon>
        Analyst Dashboard
      </a>
      <a mat-list-item [routerLink]="'/employee-documents'" (click)="sideNavOpen = false" *ngIf="isStatManager || isStatistician || isShooter">
        <mat-icon style="padding-right: 10px;">picture_as_pdf</mat-icon>
        Documents
      </a>
      <ng-container *ngIf="isFan">
        <a mat-list-item [routerLink]="'/live'" (click)="sideNavOpen = false">
          <mat-icon style="padding-right: 10px;">home</mat-icon>
          Home
        </a>
        <a mat-list-item [routerLink]="'/live/search'" (click)="sideNavOpen = false">
          <mat-icon style="padding-right: 10px;">search</mat-icon>
          Find Teams and Games
        </a>
      </ng-container>
      <a mat-list-item [routerLink]="'/resources'" (click)="sideNavOpen = false" *ngIf="hasResources">
        <mat-icon style="padding-right: 10px;">history_edu</mat-icon>
        Resources
      </a>
      <a mat-list-item [routerLink]="'/highlights'" (click)="sideNavOpen = false" *ngIf="highlightsEnabled" 
          matTooltip="View or build your next great highlight!" matTooltipPosition="right">
        <mat-icon style="padding-right: 10px;">movie</mat-icon>
        My Highlights
      </a>
      <a mat-list-item [routerLink]="'/hub'" (click)="sideNavOpen = false" matTooltip="View highlights from all QwikCut users" matTooltipPosition="right">
        <mat-icon style="padding-right: 10px;">movie_filter</mat-icon>
        Highlight Hub
      </a>
      <a mat-list-item [routerLink]="'/live'" (click)="sideNavOpen = false" *ngIf="!isFan">
        <mat-icon style="padding-right: 10px;">live_tv</mat-icon>
        Qwikcut Live
      </a>
      <a mat-list-item [routerLink]="'/products'" (click)="sideNavOpen = false">
        <mat-icon style="padding-right: 10px;">shopping_cart</mat-icon>
        Marketplace
      </a>
      <a mat-list-item [routerLink]="'/videos-review'" (click)="sideNavOpen = false" *ngIf="isShooter">
        <mat-icon style="padding-right: 10px;">video_call</mat-icon>
        Video Review
      </a>

      <div class="flex-row center-container">
        <button mat-flat-button class="hof-recruiting-btn" (click)="openRecruitmentApp(); sideNavOpen = false" *ngIf="showRecruitmentHandoff()" [matTooltip]="'Log in to HOF Recruiting'">
          <img src="assets/images/HOF_ICON_WHITE.png" alt="" class="hof-recruiting-icon">
          HOF Recruiting
        </button>
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="fill-container">
    <div class="container" style="height: 100%;">

      <mat-toolbar class="toolbar flex-row" [class.hide-nav]="hideNavBar || hideNavComponent">
        <button
          type="button"
          aria-label="Toggle Side Menu"
          mat-icon-button
          (click)="drawer.toggle()"
          *ngIf="signedIn && !isStatistician">
          <mat-icon>menu</mat-icon>
        </button>
  
        <img src="assets/images/qwikcut-q-logo.png" style="height: 75%; cursor: pointer;" [routerLink]="'/'">

        <ng-container *ngIf="signedIn">
          <button mat-button [matMenuTriggerFor]="accountMenu" style="font-size: 1rem; max-width: 30vw;">
            <div class="flex-row" style="align-items: center;">
              <div class="button-text" style="flex: 1;">{{ getUserRoleTitle() }}</div>
              <mat-icon mat-list-icon>keyboard_arrow_down</mat-icon>
            </div>
          </button>
          <mat-menu #accountMenu="matMenu" xPosition="after" class="account-menu">
            <ng-container *ngFor="let section of userRoleSections">
              <mat-label class="account-section-header">{{ section.name }}</mat-label>
              <button mat-menu-item class="account-menu-btn" *ngFor="let userRole of section.userRoles" (click)="switchUserRole(userRole)" [disabled]="isCurrentUserRole(userRole)">
                <div class="flex-row" style="align-items: flex-start;">
                  <mat-icon style="min-width: 24px;">{{ getSportIconName(userRole) }}</mat-icon>
                  <div class="flex-column" style="align-items: flex-start;">
                    <mat-label style="font-size: larger; font-weight: bold;">{{ prettifyRole(userRole.role) }}</mat-label>
                    <mat-label *ngIf="userRole.team">{{ userRole.team.name + (userRole.team.teamlevel ? ' (' + userRole.team.teamlevel.name + ')' : '') }}</mat-label>
                    <mat-label *ngIf="userRole.team && userRole.team.conference">{{ userRole.team.conference.name }}</mat-label>
                    <mat-label *ngIf="userRole.leaguePool">{{ userRole.leaguePool.name }}</mat-label>
                    <mat-label *ngIf="userRole.thirdParty">{{ userRole.thirdParty.name }}</mat-label>
                  </div>
                </div>
              </button>
              <mat-divider style="margin-bottom: 15px;"></mat-divider>
            </ng-container>
          </mat-menu>

          <ng-container *ngIf="canSwitchTeams && organizationTeams?.length">
            <button mat-button [matMenuTriggerFor]="accountMenu" style="font-size: 1rem; max-width: 30vw; margin-left: 15px;">
              <div class="flex-row" style="align-items: center;">
                <div class="button-text" style="flex: 1;">{{ getCurrentTeamTitle() }}</div>
                <mat-icon mat-list-icon>keyboard_arrow_down</mat-icon>
              </div>
            </button>
            <mat-menu #accountMenu="matMenu" xPosition="after" class="account-menu">
              <ng-container *ngFor="let team of organizationTeams">
                <button mat-menu-item class="account-menu-btn" (click)="switchTeam(team)" [disabled]="user?.team?._id === team._id">
                  <div class="flex-row" style="align-items: flex-start;">
                    <div class="flex-column" style="align-items: flex-start;">
                      <mat-label style="font-size: larger; font-weight: bold;">{{ team.name }}</mat-label>
                      <mat-label *ngIf="team.teamlevel">{{ team.teamlevel.name }}</mat-label>
                    </div>
                  </div>
                </button>
              </ng-container>
            </mat-menu>
          </ng-container>
        </ng-container>

        <span class="spacer"></span>
        <ng-container *ngIf="signedIn">
					<div class="flex-row support-pill" *ngIf="!isFan && !(isAthlete && isYouth)">
						<ng-container *ngIf="!showingZohoChat">
							<mat-label class="support-pill-label">Need Support?</mat-label>
							<button mat-flat-button color="primary" class="zoho-chat-btn" (click)="toggleZohoChat()">Let's Chat</button>
						</ng-container>
						<ng-container *ngIf="showingZohoChat">
							<mat-label class="support-pill-label">Done Chatting?</mat-label>
							<button mat-flat-button color="primary" class="zoho-chat-btn" (click)="toggleZohoChat()">Hide Chat</button>
						</ng-container>
					</div>

          <div class="flex-column" style="margin-right: 10px; cursor: pointer; width: unset;" (click)="navigateToTeamStorage()" *ngIf="showStorage">
            <div class="flex-row center-container">
              <a style="font-size: small;" *ngIf="!(isHandset$ | async)">Storage: {{ totalStorageHours?.toFixed(1) }} / {{ totalStorageLimit }} hours</a>
              <a style="font-size: small;" *ngIf="(isHandset$ | async)">{{ totalStorageHours?.toFixed(1) }}/{{ totalStorageLimit }} hrs</a>
            </div>
            <div class="flex-row center-container" style="margin-top: 3px;">
              <mat-progress-bar [color]="getStorageBarColor()" mode="determinate" [value]="(totalStorageHours * 100 / totalStorageLimit)" class="progress-bar" [style.width]="(isHandset$ | async) ? '4rem' : '8rem'"></mat-progress-bar>
            </div>
          </div>

          <button mat-button [routerLink]="'/admin-dashboard'" *ngIf="isAdmin">Admin</button>

					<ng-container *ngIf="(elevatedPriv || isShooter || (isParent && parentAbilityIsAllowed(teamSettings, 'uploadFilm'))) && !isStatistician && !isStatManager">
						<button mat-flat-button color="primary" [routerLink]="'/upload-video'" *ngIf="!(isHandset$ | async)">
							<mat-icon>cloud_upload</mat-icon>
							Upload
						</button>
						<button mat-icon-button color="primary" [routerLink]="'/upload-video'" *ngIf="(isHandset$ | async)">
							<mat-icon>cloud_upload</mat-icon>
						</button>
					</ng-container>

          <ng-container *ngIf="messengerEnabled">
            <button mat-icon-button [matMenuTriggerFor]="chatMenu" #chatMenuTrigger="matMenuTrigger" [style.margin-left]="(isHandset$ | async) ? '0' : '15px'" style="position: relative;">
              <mat-icon class="icon-filled">message</mat-icon>
              <div class="count-lastmessage" *ngIf="filterConversations && filterConversations.length > 0">{{ filterConversations.length }}</div>
            </button>
            <mat-menu #chatMenu="matMenu" (closed)="onChatMenuClosed()">
              <app-messenger *ngIf="user" [user]="user" [elevatedPriv]="elevatedPriv" (onConversationsRetrieved)="onConversationsRetrieved($event)"></app-messenger>
            </mat-menu>
          </ng-container>

          <button
            mat-icon-button
            class="theme-toggle-btn"
            [attr.aria-label]="theme === 'light' ? 'Use dark mode' : 'Use light mode'"
            [style.margin-left]="(isHandset$ | async) ? '0' : '15px'"
            [matTooltip]="theme === 'light' ? 'Use dark mode' : 'Use light mode'"
            matTooltipPosition="below"
            (click)="toggleTheme()">
            <span class="theme-toggle-badge" *ngIf="showThemeToggleBadge">NEW</span>
            <mat-icon class="icon-filled">{{ theme === 'light' ? 'dark_mode' : 'light_mode' }}</mat-icon>
          </button>

          <button mat-icon-button [matMenuTriggerFor]="settingsMenu" [style.margin-left]="(isHandset$ | async) ? '0' : '15px'">
            <mat-icon class="icon-filled">account_circle</mat-icon>
          </button>
          <mat-menu #settingsMenu="matMenu">
            <button mat-menu-item [routerLink]="'/api-access'" *ngIf="hasApiAccess">
              <mat-icon>vpn_key</mat-icon>
              API Access
            </button>
            <button mat-menu-item [routerLink]="'/user-account'">
              <mat-icon>manage_accounts</mat-icon>
              Manage Account
            </button>
            <button mat-menu-item (click)="manageUserNotifications()">
              <mat-icon>notifications</mat-icon> Manage Notifications
            </button>
            <button mat-menu-item [routerLink]="'/user-payments'" *ngIf="!isFan">
              <mat-icon>payments</mat-icon>
              Payments
            </button>
            <a href="https://support.qwikcut.com" target="_blank" style="text-decoration: none;">
              <button mat-menu-item>
                <mat-icon>school</mat-icon>
                Knowledge Base
              </button>
            </a>
            <button mat-menu-item (click)="logout()">
              <mat-icon>logout</mat-icon>
              Logout
            </button>
          </mat-menu>
        </ng-container>
      </mat-toolbar>

      <!-- This is so the content scrolls separate from the toolbar -->
      <div class="flex-fill" style="flex: 1;">
        <div class="container" style="height: 100%;">
          <div class="fill-container">
            <router-outlet class="container"></router-outlet>
          </div>
        </div>
      </div>

    </div>
  </mat-sidenav-content>

</mat-sidenav-container>
